import { AustralianState, CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { useAppSelector } from './useAppSelector';
import { AppFeatures } from '@urbanx/agx.agencies.client';

export const useFeatureToggles = (state?: AustralianState | CampaignDetailModelState): AppFeatures => {
  const { featureToggles } = useAppSelector(state => state.agentInfo);

  if (!featureToggles || !state) return {};

  return featureToggles[state] ?? {};
};
